<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <trajectory-project-form/>
        </b-card>
    </div>
</template>

<script>
    import TrajectoryProjectForm from '~/components/forms/admin/projects/trajectory-project/form'

    export default {
        name: 'create',

        components: {
            'trajectory-project-form': TrajectoryProjectForm,
        },
    }
</script>

<style lang="css" scoped>
</style>